export function FilterButton({isActive, name, onclick, ...prop}) {
    return (
        <div {...prop}
             onClick={onclick}
             className={"filter-button-v7 " + (isActive ? "active" : "")}>
            <span className={"filter-button-text"}>{name}</span>
        </div>
    );
}